import {
    IPrimitivePaneRenderer,
    IPrimitivePaneView,
    PrimitivePaneViewZOrder
} from 'lightweight-charts'
import LabelledVerticalLineDrawing from './plusIcon.drawing'
import VerticalLinePaneRenderer from './plusIcon.paneRenderer'

class LabelledVerticalLinePaneView implements IPrimitivePaneView {
    drawing: LabelledVerticalLineDrawing
    paneRenderer: VerticalLinePaneRenderer;

    constructor(drawing: LabelledVerticalLineDrawing) {
        this.drawing = drawing;
        this.paneRenderer = new VerticalLinePaneRenderer(this.drawing);
    }

    zOrder(): PrimitivePaneViewZOrder {
        return 'top'
    }

    renderer(): IPrimitivePaneRenderer | null {
        return this.paneRenderer
    }
    destroy() {
        this.paneRenderer.destroy();
        this.paneRenderer = null;
    }
}


export default LabelledVerticalLinePaneView